import { BooleanInput } from "@/components/admin/boolean-input";
import { Edit } from "@/components/admin/edit";
import { NumberInput } from "@/components/admin/number-input";
import { SimpleForm } from "@/components/admin/simple-form";
import { TextInput } from "@/components/admin/text-input";
import { required } from "ra-core";

export const FormationEdit = () => (
  <Edit title="Modifier la formation">
    <SimpleForm>
      <TextInput source="reference" label="Référence" />
      <TextInput source="titre" label="Intitulé" validate={required()} />
      <NumberInput
        source="duree_jours"
        label="Durée (jours)"
        validate={required()}
      />
      <NumberInput
        source="duree_heures"
        label="Durée (heures)"
        validate={required()}
      />
      <NumberInput source="tarif_ht" label="Tarif HT par groupe de 1 à 4 (€)" />
      <BooleanInput source="actif" label="Active" />
    </SimpleForm>
  </Edit>
);
